<template>
  <el-container class=".el-container" direction="vertical">
    <Header />
    <el-container>
      <Aside />
      <el-main class=".el-main">
        <el-backtop target=".el-main"></el-backtop>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/";
import Aside from "@/components/Aside/";
export default {
  name: "Home",
  components: {
    Header,
    Aside,
  },
};
</script>

<style lang="less" scoped>
@import "~@/style/mixin.less";
.el-container {
  height: 100%;
  overflow-y: hidden;
}

.el-main {
  height: calc(100vh - 60px);
  box-sizing: border-box;
  background: #f4f5f9;
  .self-scrollbar;
}

.el-aside {
  overflow-x: hidden;
  scrollbar-width: none;
}

.el-aside::-webkit-scrollbar {
  display: none;
}
</style>
